export const sprintf = (str, ...argv) => {
    if (argv.length === 0) {
        return str;
    }

    return sprintf(str.replace(sprintf.token || '%s', argv.shift()), ...argv);
};
